import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { VenueContactUsersQuery } from './__generated__/form_user_query'
import { Query } from './form_user_query'
import { VenueContactAttributes } from '@/types'

interface Props {
  attributes: VenueContactAttributes
  setAttributes: React.Dispatch<React.SetStateAction<VenueContactAttributes>>
}

export const useUserContact = ({ attributes, setAttributes }: Props) => {
  const [pickedUser, setPickedUser] = useState(false)
  const { data } = useQuery<VenueContactUsersQuery>(Query, { variables: { userId: attributes.userId } })

  useEffect(() => {
    if (attributes.userId) {
      setPickedUser(true)
    } else {
      setPickedUser(false)
    }
  }, [attributes])

  useEffect(() => {
    if (data && pickedUser) {
      const user = data.users.nodes[0]

      setAttributes({ ...attributes, name: user.displayName, email: user.email, phone: user.phone || '' })
    }
  }, [attributes, setAttributes, data, pickedUser])

  return { pickedUser }
}
